import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Toast ,Modal} from 'antd-mobile'
import { History } from 'history'
import { withRouter } from 'react-router'
import './pay-group.less'
import {
  postPaying as postPayingApi,
  postAddBill as postAddBillApi,
  addBillForceApi
} from '@/api/payment'
const AModal: any = Modal
interface Props {
  history?: History,
  payBack?:any,
  money?: string | number
  data?: any
  checkin_id?: string
  loadData: () => any
}
const mapStateToProps = (state: any) => {
  const { checkin_id } = state.payment
  return {
    checkin_id,
  }
}

const PayGroup = (props: Props&any) => {
  const [modal, setModal] = useState(false);
  const [modalText, setModalText] = useState(false);
  const { money, loadData, checkin_id,payBack } = props

  const pay = async () => {
    const { pay_type, cost_data } = loadData()
    const {subject_id} =cost_data[0]
    const params = {
      cost_type: 'recharge',
      pay_type,
      cost_data,
      money,
      checkin_id,
    }
    window.paySuccessBack = () => {
      if(payBack){
        payBack()
      }else{
        Toast.success('支付成功', 3, ()=> {
          if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
        })
      }
    }

    const { data } = await postPayingApi(params)
    if (data.code === 'SUCCESS') {
      let dataString = JSON.stringify(data.data.config)
      if (pay_type === 'alipay') {
        if (window.WebViewBridge) {
          window.WebViewBridge?.aliPayOld?.call(window.WebViewBridge, dataString)
        } else if (window.webkit) {
          window.webkit.messageHandlers.aliPayOld.postMessage(dataString)
        }
      } else {
        if (window.WebViewBridge) {
          window.WebViewBridge?.weChatPay?.call(window.WebViewBridge, dataString)
        } else if (window.webkit) {
          window.webkit.messageHandlers.weChatPay.postMessage(dataString)
        }
      }
    }else if(subject_id ==='13005'&&data.code==='HAVE_DEBT_CANCEL'){
      //未缴纳的冷水费欠款，添加到账单
      setModalText(data.msg)
      setModal(true)
    }
    else{
      Toast.info(data.msg, 1)
    }

  }

  const addBill = async () => {
    const { cost_data } = loadData()
    const {subject_id} =cost_data[0]
    let params: any = { checkin_id }
    for (let key in cost_data[0]) {
      params[key] = cost_data[0][key]
    }
    
    const { data } = await postAddBillApi(params)

    if (data.code === 'SUCCESS') {
      Toast.success('添加账单成功', 1, ()=> {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      };
        window.WebViewBridge?.addBillSuccess?.call(window.WebViewBridge)
      });
    }else if(subject_id ==='13005'&&data.code==='HAVE_DEBT_CANCEL'){
      //未缴纳的冷水费欠款，添加到账单
      setModalText(data.msg)
      setModal(true)
    } else {
      Toast.fail(data.msg, 1)
    }
  }
  
  const onClose = async () => {
    setModal(false)
  }
  //添加到账单
  const addArrears = async () => {
    const { cost_data } = loadData()
    let params: any = { checkin_id }
    for (let key in cost_data[0]) {
      params[key] = cost_data[0][key]
    }
    const { data } = await addBillForceApi(params)
    if (data.code === 'SUCCESS') {
      const { history} = props
      history.push(`/payment/bill/0`)
      
    }else{
      setModal(false)
      Toast.info("添加账单失败", 3)
    }
  }
  
  return (
    <div className="pay-btn-group">
      <span className="sum">
        合计：{money && parseFloat(money as string).toFixed(2)}元
      </span>
      <span className="add-bill">
        <button onClick={addBill}>加入账单</button>
      </span>
      <span className="pay">
        <button onClick={pay}>付款</button>
      </span>

      <AModal
          visible={modal}
          transparent
          maskClosable={false}
          title="提示"
          footer={[{ text: '取消', onPress: () => onClose() },{ text: '确定', onPress: () => {  addArrears(); } }]}
        >
          <div >
          {modalText}
          </div>
        </AModal>
    </div>
  )
}

// export default
export default connect(mapStateToProps)(withRouter(PayGroup))